import { render } from "./Checkbox.vue?vue&type=template&id=28e7d61c"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"
script.render = render

export default script